// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormUploadSuppliers } from '../../forms/FormUploadSuppliers/FormUploadSuppliers';

// props
export interface DialogUploadSuppliersProps {
	isOpen: boolean;
	onSuccess?: () => void;
	onClose: () => void;
}

export const DialogUploadSuppliers = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogUploadSuppliersProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('uploadSuppliers'),
					form: 'form-upload-suppliers',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={700}
			onClose={onClose}
			title={{
				children: t('uploadSuppliers'),
				variant: 'h3',
			}}>
			<FormUploadSuppliers onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
